import { render, staticRenderFns } from "./LeaveMassageIndex.vue?vue&type=template&id=e7291c80&scoped=true&"
import script from "./LeaveMassageIndex.vue?vue&type=script&lang=js&"
export * from "./LeaveMassageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7291c80",
  null
  
)

export default component.exports